var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    {
      staticClass: "app-pagination",
      class: { "app-pagination--disabled": _vm.$attrs.disabled }
    },
    [
      _c(
        "li",
        {
          staticClass: "app-pagination__page",
          class: { "app-pagination__page--disabled": Number(_vm.value) === 1 },
          on: {
            click: function($event) {
              _vm.$emit("change", Number(_vm.value) - 1)
            }
          }
        },
        [
          _c("div", {
            staticClass: "app-pagination__arrow app-pagination__arrow--left"
          })
        ]
      ),
      _vm._v(" "),
      _vm._l(_vm.pagination, function(page, index) {
        return _c(
          "li",
          {
            key: index,
            staticClass: "app-pagination__page",
            class: {
              "app-pagination__page--disabled": page === "...",
              "app-pagination__page--active": page === Number(_vm.value)
            },
            on: {
              click: function($event) {
                $event.stopPropagation()
                return _vm.$emit("change", page)
              }
            }
          },
          [_vm._v("\n\t\t" + _vm._s(page) + "\n\t")]
        )
      }),
      _vm._v(" "),
      _c(
        "li",
        {
          staticClass: "app-pagination__page",
          class: {
            "app-pagination__page--disabled": Number(_vm.value) === _vm.total
          },
          on: {
            click: function($event) {
              _vm.$emit("change", Number(_vm.value) + 1)
            }
          }
        },
        [
          _c("div", {
            staticClass: "app-pagination__arrow app-pagination__arrow--right"
          })
        ]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-50edb07e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50edb07e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/app-components/AppPagination.vue
// module id = null
// module chunks = 